import { useSelector } from 'react-redux';

import { DEFAULT_SEARCH_DAYS, localeFromTranslations } from '~helpers/defaultSearch';

const HOUR = 3600;

export const useDefaultWish = () => {
  const { translations } = useSelector((state) => state.domainConfig);
  const locale = localeFromTranslations(translations);

  return {
    address: null,
    duration: 3 * HOUR, // 3 hours
    interval: 1, // weekly
    timeframes: DEFAULT_SEARCH_DAYS,
    languages: [locale],
    attributes: [],
    personalNote: '',
    published: true,
  };
};
